// @flow

export const USER_AUTH = 'USER_AUTH';
export const ADMIN_BUSINESS_ID = 'ADMIN_BUSINESS_ID';
export const PROSPECT_INFORMATION = 'PROSPECT_INFORMATION';
